import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["use", "children", "backgroundColor"];
import { Flex } from '../../../components/Flex';
import { DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE } from '../../constants';
import { getVariantStyles } from './ToolBar.helpers';
import styled from 'foundations-theming/utils';
import { StyledLink } from '../Link/Link';
import { StyledToolBarGroup } from '../ToolBarGroup/ToolBarGroup';
import { StyledNav } from '../Breadcrumbs/Breadcrumbs';
import { Affordance as AutoSizedTextInputAffordance, StyledIconWrapper as AutoSizedTextInputIconWrapper } from '../AutoSizedTextInput/AutoSizedTextInput';
import { ToolBarContext } from './ToolBarContext';
import { useTheme } from 'foundations-theming/utils';
import { canReadText } from '../../utils/color';
import { jsx as _jsx } from "react/jsx-runtime";
export const StyledToolBar = styled.div.withConfig({
  displayName: "ToolBar__StyledToolBar"
})(({
  theme,
  $use,
  $isFilled
}) => {
  return Object.assign({
    [`& ${StyledNav}`]: {
      // using the size of the text to make sure this is perfectly aligned
      lineHeight: theme.typography['body-100'].fontSize
    }
  }, $use !== 'filter-bar' && $use !== 'tabs' && {
    [`& ${StyledLink}`]: {
      fontSize: theme.typography['heading-50'].fontSize,
      ':focus': {
        // link focus box shadow doesn't play nice with the toolbar
        boxShadow: 'none!important'
      }
    }
  }, $isFilled && {
    [`& ${StyledToolBarGroup}, & ${AutoSizedTextInputAffordance}, & ${AutoSizedTextInputIconWrapper}`]: {
      color: theme.color['text-core-on-fill-default']
    }
  }, !$isFilled && {
    [`& ${StyledToolBarGroup}, & ${AutoSizedTextInputAffordance}, & ${AutoSizedTextInputIconWrapper}`]: {
      color: theme.color['text-core-default']
    }
  });
});
export const ToolBar = _ref => {
  let {
      use = 'default',
      children,
      backgroundColor
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const variantStyles = getVariantStyles(use);
  const theme = useTheme();
  const isFilled = backgroundColor ?
  // if on-fill text can be read on the custom background color it can be considered filled
  canReadText(theme.color[backgroundColor], theme.color['text-core-on-fill-default']) :
  // default and dark are the same: both uses are accepted here for backwards compatibility
  use === 'default' || use === 'dark';
  return /*#__PURE__*/_jsx(ToolBarContext.Provider, {
    value: {
      use,
      isFilled
    },
    [DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE]: 'ToolBar',
    children: /*#__PURE__*/_jsx(StyledToolBar, {
      $use: use,
      $isFilled: isFilled,
      children: /*#__PURE__*/_jsx(Flex, Object.assign({
        role: "group",
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "wrap",
        inlineSize: "100%",
        justifyContent: "space-between",
        paddingInline: "200"
      }, variantStyles, {
        backgroundColor: backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : variantStyles.backgroundColor
      }, rest, {
        children: children
      }))
    })
  });
};
ToolBar.displayName = 'ToolBar';